// Scroll reveals
document.addEventListener('DOMContentLoaded', function () {
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.dataset.revealed = 'true'; io.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  document.querySelectorAll('.reveal').forEach(function (el, i) {
    el.style.transitionDelay = (i % 5) * 80 + 'ms';
    io.observe(el);
  });

  // Parallax hero blobs
  var blobs = document.querySelectorAll('.blob');
  if (blobs.length) {
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      blobs.forEach(function (b, i) {
        b.style.transform = 'translateY(' + y * (i % 2 ? -0.1 : 0.15) + 'px)';
      });
    }, { passive: true });
  }

  // Product gallery
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.dataset.full;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', String(b === btn));
        });
      });
    });
  });

  // Variant selection
  document.querySelectorAll('[data-variants]').forEach(function (form) {
    var input = form.querySelector('[name="id"]');
    form.querySelectorAll('[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        input.value = btn.dataset.variantId;
        form.querySelectorAll('[data-variant-id]').forEach(function (b) {
          b.setAttribute('aria-current', String(b === btn));
        });
        var price = form.querySelector('[data-price]');
        if (price && btn.dataset.price) price.textContent = btn.dataset.price;
        var available = btn.dataset.available !== 'false';
        form.querySelectorAll('[data-atc]').forEach(function (cta) {
          cta.disabled = !available;
          cta.textContent = available ? (cta.dataset.label || 'Add to cart') : 'Sold out';
        });
      });
    });
  });
});
